"use client";
import { Editor, NodeViewWrapper } from "@tiptap/react";
import i18next from "i18next";
import { ImagePlus } from "lucide-react";
import { useCallback, useState } from "react";
import {
  AssetReturnType,
  AssetType,
  openAssetHQType,
} from "src/fields/TiptapEditor/types.js";
import { getAssetActualSize } from "../getImageActualSize.js";
export const ImageUploadBuilder = (openAssetHQHandler: openAssetHQType) => {
  const ImageUpload = ({
    getPos,
    editor,
    node,
  }: {
    getPos: () => number;
    editor: Editor;
    node: { attrs: { type?: AssetType } };
  }) => {
    const [done, setDone] = useState(false);
    const onUpload = useCallback(
      (asset: AssetReturnType) => {
        if (asset && !done) {
          let title = asset.title;
          if (
            i18next.language !== "en" &&
            !!asset.title_locale[i18next.language.toUpperCase()]
          ) {
            title = asset.title_locale[i18next.language.toUpperCase()];
          }
          const { actualWidth, actualHeight } = getAssetActualSize(asset);
          if (asset.type === "IMAGE") {
            editor
              .chain()
              .focus()
              .setImageBlock({
                src: asset?.optimizedImageUrl || asset.fullUrl,
                assetId: asset.id,
                caption: title,
                actualWidth: actualWidth,
                actualHeight: actualHeight,
              })
              .deleteRange({ from: getPos(), to: getPos() })
              .focus()
              .run();
            setDone(true);
          } else {
            console.log("calling editor setVideoBlock.", {
              src: asset.videoUrl,
              poster: asset.fullUrl,
              assetId: asset.id,
              playlistUrl: asset.playlistUrl,
            });
            const { actualHeight, actualWidth } = getAssetActualSize(asset);
            editor
              .chain()
              .focus()
              .setVideoBlock({
                src: asset.videoUrl,
                poster: asset.fullUrl,
                assetId: asset.id,
                playlistUrl: asset.playlistUrl,
                title: title,
                actualHeight,
                actualWidth,
              })
              .deleteRange({ from: getPos(), to: getPos() })
              .focus()
              .run();
            setDone(true);
          }
        } else {
          console.info(
            "ImageUpload onUpload called but this is a finished component."
          );
        }
      },
      [getPos, editor]
    );

    return (
      <NodeViewWrapper>
        <div className="p-0 m-0" data-drag-handle>
          <a
            href="#"
            className="text-black text-sm font-medium uppercase hover:cursor-pointer p-2.5 bg-white rounded-[7px] transition ease-in-out delay-150 hover:scale-110 hover:bg-amber-600 shadow justify-between items-center flex flex-row"
            onClick={(e) => {
              e.preventDefault();
              openAssetHQHandler(onUpload, null, node?.attrs?.type ?? "image");
            }}
          >
            <ImagePlus className="mr-2" />
            Select an asset
          </a>
        </div>
      </NodeViewWrapper>
    );
  };

  return ImageUpload;
};
